<template>
  <ion-row>
    <ion-col class="text-center">
      <ion-icon src="/assets/security/security-lock.svg" class="w-[140px] h-[150px] fadein-400 mb-2"></ion-icon>
      <ion-text class="text-xl font-bold ion-text-brand mt-6 block">Password Changed Successfully</ion-text>
    </ion-col>
  </ion-row>
</template>

